export default __webpack_public_path__ + "static/media/m3.f46b6325.jpg";